import encrypt from "@/plugins/encrypt.js";
import { ElMessage, ElMessageBox } from "element-plus";

class WebSocketService {
  constructor(url) {
    this.url = url
    this.ws = null
    this.isConnected = false
    this.messages = []
    this.heartbeatTimer = null
  }

  connect() {
    if (this.ws && (this.ws.readyState === 1 || this.ws.readyState === 0)) {
      // 已连接或正在连接
      return
    }

    this.ws = new window.WebSocket(this.url)
    this.ws.onopen = () => {
      this.isConnected = true
      this.startHeartbeat()
      console.log('WebSocket 连接已建立')

      // 建立连接，发送用户信息
      this.sendMessage(
        encrypt.aesEncrypt({
          socket_mess_type: 'user_id',
          user_id: this.getCookie('user_id')
        })
      )
    }
    this.ws.onmessage = (event) => {
      let data = JSON.parse(event.data)
      if (parseInt(data.Code) === 200 && data.Data && data.Data.encryption) {
        let decryptData = encrypt.aesDecrypt(data.Data.encryption);
        if (decryptData.socket_mess_type === 'Message') {
          ElMessage.success(data.Message);
        }
        if (decryptData.socket_mess_type === 'order_report') {
          ElMessageBox.confirm(
            data.Message,
            '温馨提示',
            {
              confirmButtonText: '导出',
              cancelButtonText: '取消'
            }
          )
            .then(() => {
              window.open(decryptData.data);
            })
            .catch(() => {
              ElMessage.error('已取消导出');
            })

        }
      } else if (parseInt(data.Code) === 202) {
        ElMessage.error(data.Message);
      }
    }
    this.ws.onclose = () => {
      this.isConnected = false
      this.stopHeartbeat()
      console.log('WebSocket 连接已关闭')
    }
    this.ws.onerror = (err) => {
      this.stopHeartbeat()
      console.error('WebSocket 错误:', err)
    }
  }

  sendMessage(message) {
    if (this.ws && this.isConnected) {
      this.ws.send(message)
    }
  }

  startHeartbeat() {
    this.heartbeatTimer = setInterval(() => {
      this.sendMessage(encrypt.aesEncrypt({
        socket_mess_type: 'heartbeat'
      }));
    }, 20000)
  }

  stopHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer)
      this.heartbeatTimer = null
    }
  }

  disconnect() {
    if (this.ws) {
      this.ws.close()
    }
    this.stopHeartbeat()
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }
}

export default WebSocketService